import { fetchWrapAroundStatusFor, nullifyTransforms } from "./helpers"

// import { handleScaleRotateEffectFor } from "./rotate-effect"
import { renderPillsFor, mountPillsListeners } from "./pills"
import { mountArrowsListeners } from "./arrows"
import { handleHoverStateFor } from "./hover-state"
export { adjustContainerHeightFor } from "./dynamic-height"
import { adjustContainerHeightFor } from "./dynamic-height"

import { getDimensionFor } from "./direction-helpers"

import { handleDragFor } from "./drag"

const clamp = (n, min, max) => Math.min(Math.max(n, min), max)

const DESTROYED = "__DESTROYED__"

export class Flexy {
  getDefaultState = () => ({
    elementsOnBehind: 1,

    positionSnapshot: 0,
    positionX: 0,

    /**
     * The thing the algorithm tends to move the slides to
     */
    positionTarget: 0,

    velocity: 0,

    containerInnerWidth: this.sliderContainer
      ? getDimensionFor(
          nullifyTransforms(this.sliderContainer, this.nullifyTransformEl),
          this
        )
      : 0,

    slideWidth: this.sliderContainer
      ? getDimensionFor(
          nullifyTransforms(
            this.sliderContainer.firstElementChild,
            this.sliderContainer
          ),
          this
        )
      : 0,

    previousCurrentIndex: 0,

    startX: 0,
    endX: 0,
    mouseDown: false,

    lastTimeAnimated: Infinity,
  })

  state = this.getDefaultState()

  options = {
    onDragStart: () => {},
    autoplay: false,
    scaleRotateEffect: false,
    pillsContainerSelector: null,
    pillsFlexyInstance: null,
    flexyAttributeEl: null,

    initialDragEvent: null,

    adjustHeight: false,

    // container | viewport
    wrapAroundMode: "container",

    // horizontal | vertical
    orientation: "horizontal",

    nullifyTransformEl: null,

    elementsThatDoNotStartDrag: [],

    hasDragAndDrop: true,
  }

  sliderContainer = null

  constructor(sliderContainer, options = {}) {
    this.options = {
      ...this.options,
      flexyAttributeEl: sliderContainer,
      nullifyTransformEl: sliderContainer,
      ...options,
    }

    this.sliderContainer = sliderContainer

    mountPillsListeners(this)
    mountArrowsListeners(this)
    handleHoverStateFor(this)

    handleDragFor(
      this,
      () => this.state,
      (newState) => (this.state = newState)
    )
    ;[...this.sliderContainer.children].map((singleSlide) =>
      singleSlide.addEventListener(
        "click",
        (e) =>
          Math.abs(this.state.startX - this.state.endX) > 3 &&
          e.preventDefault()
      )
    )

    let elementsOnBehind = 1
    let firstItem = 1

    let flexyAttributeElStyle = getComputedStyle(this.options.flexyAttributeEl)

    if (flexyAttributeElStyle.getPropertyValue("--current-item")) {
      firstItem = parseInt(
        flexyAttributeElStyle.getPropertyValue("--current-item")
      )

      elementsOnBehind = this.sliderContainer.children.length
    }

    this.state = {
      ...this.state,
      elementsOnBehind,
      positionX:
        getDimensionFor(
          nullifyTransforms(
            this.sliderContainer.firstElementChild,
            this.options.nullifyTransformEl
          ),
          this
        ) *
        firstItem *
        -1,
      positionTarget:
        getDimensionFor(
          nullifyTransforms(
            this.sliderContainer.firstElementChild,
            this.options.nullifyTransformEl
          ),
          this
        ) *
        firstItem *
        -1,
      containerInnerWidth: getDimensionFor(
        nullifyTransforms(this.sliderContainer, this.nullifyTransformEl),
        this
      ),
      slideWidth: getDimensionFor(
        nullifyTransforms(
          this.sliderContainer.firstElementChild,
          this.options.nullifyTransformEl
        ),
        this
      ),
    }

    this.refreshActivation()
    requestAnimationFrame(() => this.drawLoop(true))
    adjustContainerHeightFor(this)
  }

  destroy() {
    this.state = {
      ...this.state,
      sliderActivated: DESTROYED,
    }
  }

  refreshActivation() {
    let totalSlidesWidth =
      getDimensionFor(
        nullifyTransforms(
          this.sliderContainer.children[0],
          this.options.nullifyTransformEl
        ) || {
          width: 0,
          height: 0,
        },
        this
      ) * this.sliderContainer.children.length

    this.state = {
      ...this.state,
      sliderActivated: this.sliderContainer
        ? getComputedStyle(this.sliderContainer, ":after").content.indexOf(
            "no-flexy"
          ) === -1 &&
          totalSlidesWidth >
            getDimensionFor(
              nullifyTransforms(
                this.sliderContainer,
                this.options.nullifyTransformEl
              ),
              this
            ) +
              10
        : false,

      /*
      &&
          totalSlidesWidth > window.innerWidth
          */
    }

    if (this.state.sliderActivated) {
      this.options.flexyAttributeEl.dataset.flexy = ""
    } else {
      this.options.flexyAttributeEl.removeAttribute("data-flexy")
      ;[...this.sliderContainer.children].map((el) =>
        el.removeAttribute("style")
      )
    }
  }

  drawLoop = (fallThroughTheFirstDraw = false) => {
    let oldPositionX = fallThroughTheFirstDraw ? Infinity : this.state.positionX

    // TODO: maybe do a smarter destroy
    if (this.state.sliderActivated === DESTROYED) {
      return
    }

    if (
      this.state.containerInnerWidth !==
      nullifyTransforms(this.sliderContainer, this.nullifyTransformEl).width
    ) {
      this.refreshActivation()
    }

    this.state = {
      ...this.state,
      ...(this.state.sliderActivated
        ? ((t, c) => c(t))(
            this.state.velocity +
              /**
               * Apply different forces based on the conditions
               */
              (this.state.mouseDown
                ? this.state.positionSnapshot +
                  (this.state.endX - this.state.startX) -
                  this.state.positionX -
                  this.state.velocity
                : (this.state.positionTarget - this.state.positionX) * 0.02),

            (velocity) => ({
              velocity: velocity * 0.72,
              positionX: this.state.positionX + velocity,
            })
          )
        : {}),
      ...(this.state.sliderActivated &&
      Math.abs(
        this.state.containerInnerWidth -
          getDimensionFor(
            nullifyTransforms(this.sliderContainer, this.nullifyTransformEl),
            this
          )
      ) > 1
        ? {
            positionX: Math.round(
              (getDimensionFor(
                nullifyTransforms(
                  this.sliderContainer.firstElementChild,
                  this.options.nullifyTransformEl
                ),
                this
              ) *
                (Math.round(this.state.positionX / this.state.slideWidth) *
                  100)) /
                100
            ),
            positionTarget: Math.round(
              (getDimensionFor(
                nullifyTransforms(
                  this.sliderContainer.firstElementChild,
                  this.options.nullifyTransformEl
                ),
                this
              ) *
                (Math.round(this.state.positionX / this.state.slideWidth) *
                  100)) /
                100
            ),
          }
        : {}),
      scrollPosition: {
        x: window.pageXOffset,
        y: window.pageYOffset,
      },
      containerInnerWidth: getDimensionFor(
        nullifyTransforms(this.sliderContainer, this.nullifyTransformEl),
        this
      ),
      slideWidth: getDimensionFor(
        nullifyTransforms(
          this.sliderContainer.firstElementChild,
          this.options.nullifyTransformEl
        ),
        this
      ),
    }

    if (
      (oldPositionX !== this.state.positionX ||
        Math.abs(this.state.positionX - this.state.positionTarget) > 0.1) &&
      !fallThroughTheFirstDraw
    ) {
      if (this.state.sliderActivated) {
        let { relativeDelta, elementsOnBehind } = fetchWrapAroundStatusFor(
          this,
          this.state.elementsOnBehind,
          this.state.mouseDown
            ? this.state.endX <= this.state.startX
              ? "right"
              : "left"
            : this.state.positionX >= this.state.positionTarget
            ? "right"
            : "left",

          this.options.wrapAroundMode
        )

        this.state = {
          ...this.state,
          elementsOnBehind,
          positionTarget: this.state.positionTarget + relativeDelta,
          positionX: this.state.positionX + relativeDelta,
          positionSnapshot: this.state.positionSnapshot + relativeDelta,
        }
      }
    }

    if (this.options.autoplay && this.state.sliderActivated) {
      if (Math.abs(this.state.positionX - this.state.positionTarget) < 0.5) {
        if (
          new Date().getTime() / 1000 - this.state.lastTimeAnimated / 1000 >
          (parseFloat(this.options.autoplay, 10)
            ? parseFloat(this.options.autoplay, 10)
            : 3)
        ) {
          this.state = {
            ...this.state,
            positionTarget:
              this.state.positionX -
              getDimensionFor(
                nullifyTransforms(
                  this.sliderContainer.firstElementChild,
                  this.options.nullifyTransformEl
                ),
                this
              ),
          }
        }
      }
    }

    if (!this.state.mouseDown && this.state.sliderActivated) {
      if (Math.abs(this.state.positionX - this.state.positionTarget) < 0.2) {
        this.state = {
          ...this.state,
          positionX: this.state.positionTarget,
          velocity: 0,
        }
      }

      let oldIndex = this.state.previousCurrentIndex

      this.state = {
        ...this.state,
        previousCurrentIndex: clamp(
          this.state.elementsOnBehind >
            Math.round(
              Math.abs(this.state.positionTarget) /
                getDimensionFor(
                  nullifyTransforms(
                    this.sliderContainer.firstElementChild,
                    this.options.nullifyTransformEl
                  ),
                  this
                )
            )
            ? Math.round(
                Math.abs(this.state.positionTarget) /
                  getDimensionFor(
                    nullifyTransforms(
                      this.sliderContainer.firstElementChild,
                      this.options.nullifyTransformEl
                    ),
                    this
                  )
              ) +
                (this.sliderContainer.children.length -
                  this.state.elementsOnBehind)
            : Math.abs(
                Math.round(
                  Math.abs(this.state.positionTarget) /
                    getDimensionFor(
                      nullifyTransforms(
                        this.sliderContainer.firstElementChild,
                        this.options.nullifyTransformEl
                      ),
                      this
                    )
                ) - this.state.elementsOnBehind
              ),
          0,
          this.sliderContainer.children.length - 1
        ),
      }

      if (oldIndex !== this.state.previousCurrentIndex) {
        renderPillsFor(this)
        adjustContainerHeightFor(this)
        ;[...this.sliderContainer.querySelectorAll("video")].map((video) => {
          video.pause()
        })
        ;[...this.sliderContainer.querySelectorAll('iframe[src*="youtu"]')].map(
          (i) => {
            i.contentWindow.postMessage(
              '{"event":"command","func":"stopVideo","args":""}',
              "*"
            )
          }
        )
        ;[
          ...this.sliderContainer.querySelectorAll(
            'iframe:not([src*="youtu"])'
          ),
        ].map((i) => {
          const source = i.src
          i.src = ""
          i.src = source
        })
      }
    }

    if (this.state.positionX !== oldPositionX && this.state.sliderActivated) {
      this.render()

      // handleScaleRotateEffectFor(this)

      this.state = {
        ...this.state,
        lastTimeAnimated: new Date().getTime(),
      }
    }

    requestAnimationFrame(() => this.drawLoop())
  }

  render() {
    ;[...this.sliderContainer.children].map((el) => {
      if (this.options.orientation === "vertical") {
        el.style.transform = `translate3d(0, ${this.state.positionX}px, 0)`
      } else {
        el.style.transform = `translate3d(${this.state.positionX}px, 0, 0)`
      }
    })

    if (this.state.mouseDown) {
      this.options.flexyAttributeEl.dataset.flexyDragging = ""
    } else {
      this.options.flexyAttributeEl.removeAttribute("data-flexy-dragging")
    }

    if (this.state.elementsOnBehind > 0) {
      ;[...this.sliderContainer.children]
        .slice(0, this.state.elementsOnBehind * -1)
        .map((el) => (el.style.order = 2))
      ;[...this.sliderContainer.children]
        .slice(this.state.elementsOnBehind * -1)
        .map((el) => (el.style.order = 1))
    } else {
      ;[...this.sliderContainer.children].map((el) => (el.style.order = 1))
    }
  }
}
